
// Utilities
import { getParentGeoId, useFetchWrapper, useHandleError } from '../helpers';
import { APIS } from '../constants';
import { errorState, selectedGeoDropdownState } from '../states';
import { useRecoilValue, useSetRecoilState } from 'recoil';



const useDashboardService = () => {
    const fetchWrapper = useFetchWrapper();
    const { getErrorMsg } = useHandleError();
    const setError = useSetRecoilState(errorState);
    const selectedGeoDropdown = useRecoilValue(selectedGeoDropdownState);

    const normalizeGeoId = (geoId: any) =>
        geoId == 1 || geoId === '1' ? 'EW-IN-IND-22-0' : geoId;

    const normalizePayload = (payload: any) => {
        if (!payload) return payload;
        const result = { ...payload };
        if (result.geoId != null) result.geoId = normalizeGeoId(result.geoId);
        if (result.geocode != null) result.geocode = normalizeGeoId(result.geocode);
        if (result.geoCode != null) result.geoCode = normalizeGeoId(result.geoCode);
        if (result.parentgeoId != null) result.parentgeoId = normalizeGeoId(result.parentgeoId);
        return result;
    };

    const getBarGraphData = (geoCode: any, selectedGeo:any, selTab:number, selectedPoi: string[]) => {
            geoCode = normalizeGeoId(geoCode);
            const {parent} = getParentGeoId(geoCode, selectedGeo, selTab, )
            return fetchWrapper.get(`${APIS.DASHBOARD.GET_BAR_GRAPH}?geoId=${geoCode}&parentgeoId=${parent}&poi=${selectedPoi}`)
    };

    const getTreeMapData = (payload: any) => {
        return fetchWrapper.post(APIS.DASHBOARD.GET_TREE_MAP, normalizePayload(payload));
    };

    const getBreakdownTableData = (payload: any) => {
        return fetchWrapper.post(APIS.DASHBOARD.GET_BREAKDOWN_TABLE_DATA, normalizePayload(payload))
    }

    const getSelectedTreeMapData = (geoCode: any, categoryId: any, parentid?: number) => {
        geoCode = normalizeGeoId(geoCode);
        if (selectedGeoDropdown?.geotype === "pincode") {
            return fetchWrapper.get(`${APIS.DASHBOARD.GET_TREE_MAP_FOR_SELECTED_CATEGORY}?geoId=${geoCode}&categoryId=${categoryId}&parentgeoId=${parentid}&type="pincode"`);
        }
        else {
            return fetchWrapper.get(`${APIS.DASHBOARD.GET_TREE_MAP_FOR_SELECTED_CATEGORY}?geoId=${geoCode}&categoryId=${categoryId}&parentgeoId=${parentid}`)
        }
    };

    const getHighlightsData = (payload: any) => {
        return fetchWrapper.post(APIS.DASHBOARD.GET_HIGHLIGHTS_FOR_ALL_CATEGORIES, normalizePayload(payload));
    };

    const getkpivalues = (payload: any) => {
        return fetchWrapper.post(APIS.DASHBOARD.GET_KPI_VALUES, normalizePayload(payload));
    }

    const getGrowthInTimePoiData = (payload: any) => {
        return fetchWrapper.post(APIS.DASHBOARD.GET_GROWTHINTIME_POIDATA, normalizePayload(payload));
    }

    const getSelectedCategoryHighlights = (geoCode: any, categoryId: any, parentid?: number) => {
            geoCode = normalizeGeoId(geoCode);
            if (selectedGeoDropdown?.geotype === "pincode") {
                return fetchWrapper.get(`${APIS.DASHBOARD.GET_DEEP_DIVE_HIGHLIGHTS}?geoId=${geoCode}&categoryId=${categoryId}&parentgeoId=${parentid}&type="pincode"`);
        }
        else {
            return fetchWrapper.get(`${APIS.DASHBOARD.GET_DEEP_DIVE_HIGHLIGHTS}?geoId=${geoCode}&categoryId=${categoryId}&parentgeoId=${parentid}`);
        }

    }

    const getGrowthInTimePoiDataByCategory = (payload: any) => {
        return fetchWrapper.post(APIS.DASHBOARD.GET_GROWTHINTIME_POIDATA_BY_CATEGORY, normalizePayload(payload));
    }
    const requestDownloadData = async (payload: any) => {
        try {
            const response = await fetchWrapper.post(APIS.DASHBOARD.REQUEST_DOWNLOAD_DATA, normalizePayload(payload));
            if (response) {
                setError({ type: 'Data Requested', message: response.detail });
            }
        } catch (error) {
            getErrorMsg(error);
        }
    }

    const getGrowthInTimePoiDataBySubcategory = (payload: any) => {
        return fetchWrapper.post(APIS.DASHBOARD.GET_GROWTHINTIME_POIDATA_BY_SUBCATEGORY, normalizePayload(payload));
    }
    const getGrowthRateAllSubCategories = (payload: any) => {
        return fetchWrapper.post(APIS.DASHBOARD.GET_GROWTHRATE_ALL_SUBCATEGORIES, normalizePayload(payload));
    }

    const getFilteredHighlights = (payload: any) => {
        return fetchWrapper.post(APIS.DASHBOARD.GET_FILTERED_HIGHLIGHTS, normalizePayload(payload));
    }

    const getPresencedetails = (geoCode: any) => {
        geoCode = normalizeGeoId(geoCode);
        return fetchWrapper.get(`${APIS.DASHBOARD.GET_PRESENCE_DETAILS}?geoId=${geoCode}`);
    }

    const getFilteredDropdown = (geoCode: any) => {
        geoCode = normalizeGeoId(geoCode);
        return fetchWrapper.get(`${APIS.DASHBOARD.GET_FILTERED_DROPDOWN}?geoId=${geoCode}`);
    }

    const getMBPTableData = (geoCode: any, param: string, paramclass: string) => {
        geoCode = normalizeGeoId(geoCode);
        return fetchWrapper.get(`${APIS.DASHBOARD.GET_MBP_TABLE_DATA}?geoId=${geoCode}&param=${param}&paramclass=${paramclass}`)
    }

    const getMBPGraphData = (payload: any) => {
        return fetchWrapper.post(APIS.DASHBOARD.GET_MBP_GRAPH_DATA, normalizePayload(payload));
    }

    return {
        getBarGraphData,
        getBreakdownTableData,
        getTreeMapData,
        getSelectedTreeMapData,
        getHighlightsData,
        getkpivalues,
        getGrowthInTimePoiData,
        getSelectedCategoryHighlights,
        getGrowthInTimePoiDataByCategory,
        getGrowthInTimePoiDataBySubcategory,
        getGrowthRateAllSubCategories,
        requestDownloadData,
        getFilteredHighlights,
        getPresencedetails,
        getFilteredDropdown,
        getMBPTableData,
        getMBPGraphData,
    }
}

export { useDashboardService };